import React from "react";

const AcousticsSolutions = () => {
  return (
    <section className="tc-service-details section-padding">
      {/* Hero Section */}
      <div className="page-hero">
        <div className="img position-relative">
          <img
            src="\home2\assets\img\services\acuo.png"
            alt="Acoustics Solutions"
            className="img-fluid w-100 radius-6"
          />
          {/* Desktop Overlay */}
    <div className="info-overlay desktop-only d-flex align-items-end">
      <div className="container pb-40">
        <h1
          className="text-white fw-600 fsz-50 wow fadeInUp slow"
          data-wow-delay="0.2s"
        >
           Acoustics Solutions
        </h1>
        <p
          className="text-white-50 mt-10 fsz-18 wow fadeInUp slow"
          data-wow-delay="0.3s"
        >
          Innovative, durable, and aesthetically refined facade systems that define
          modern architecture.Engineered systems designed to control sound, enhance privacy, and
                optimize interior performance.
        </p>
      </div>
    </div>
  </div>

  {/* Mobile Text (below image) */}
  <div className="info-under mobile-only">
    <div className="container pt-3 pb-3">
      <h1 className="text-dark fw-600 fsz-28">Acoustics Solutions</h1>
      <p className="text-dark mt-2 fsz-15">
       Engineered systems designed to control sound, enhance privacy, and
        optimize interior performance.
      </p>
    </div>
  </div>
</div>



      {/* Main Content */}
      <div className="container mt-80">
        <div className="row justify-content-between align-items-start">
          <div className="col-lg-12">
            <div className="main-content">
             

              {/* Movable Wall */}
              <div className="solution-item mb-80">
                <h4
                  className="fsz-30 fw-600 mb-30 wow fadeInUp slow"
                  data-wow-delay="0.3s"
                >
                  1. Movable Wall Systems
                </h4>
                <ul
                  className="dots-list fsz-18 color-666 wow fadeInUp slow"
                  data-wow-delay="0.3s"
                >
                  <li className="d-flex my-3">
                    <span className="icon me-3">•</span>
                    Flexible, space-saving wall systems designed to divide large
                    areas quickly and efficiently.
                  </li>
                  <li className="d-flex my-3">
                    <span className="icon me-3">•</span>
                    Delivers exceptional sound insulation, ideal for conference
                    rooms, banquet halls, and offices.
                  </li>
                  <li className="d-flex my-3">
                    <span className="icon me-3">•</span>
                    Available in manual or automated operation for smooth mobility.
                  </li>
                </ul>
              </div>

              {/* Halspan Core */}
              <div className="solution-item mb-80">
                <h4
                  className="fsz-30 fw-600 mb-30 wow fadeInUp slow"
                  data-wow-delay="0.4s"
                >
                  2. Halspan Core Doors
                </h4>
                <ul
                  className="dots-list fsz-18 color-666 wow fadeInUp slow"
                  data-wow-delay="0.4s"
                >
                  <li className="d-flex my-3">
                    <span className="icon me-3">•</span>
                    High-performance acoustic and fire-rated door cores for superior
                    safety and sound control.
                  </li>
                  <li className="d-flex my-3">
                    <span className="icon me-3">•</span>
                    Engineered for durability, stability, and compliance with
                    international standards.
                  </li>
                  <li className="d-flex my-3">
                    <span className="icon me-3">•</span>
                    Widely used in hospitals, auditoriums, hotels, and commercial
                    spaces for noise reduction and privacy.
                  </li>
                </ul>
              </div>

              {/* CTA */}
              <div
                className="cta-section mt-50 wow fadeInUp slow text-center"
                data-wow-delay="0.5s"
              >
                <a href="/contact" className="butn butn-md butn-orange1 radius-30">
                  <span>Get a Quote for Acoustic Solutions</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AcousticsSolutions;
